export const pcQwertyUS = {
  name: 'PC QWERTY US',
  platform: 'PC',
  layout: 'QWERTY',
  region: 'US',
  keys: [
    {
      row: 0,
      keys: [
        { id: 'Escape', display: 'esc', className: 'long' },
        { id: 'F1', display: 'F1' },
        { id: 'F2', display: 'F2' },
        { id: 'F3', display: 'F3' },
        { id: 'F4', display: 'F4' },
        { id: 'F5', display: 'F5' },
        { id: 'F6', display: 'F6' },
        { id: 'F7', display: 'F7' },
        { id: 'F8', display: 'F8' },
        { id: 'F9', display: 'F9' },
        { id: 'F10', display: 'F10' },
        { id: 'F11', display: 'F11' },
        { id: 'F12', display: 'F12' },
      ]
    },
    {
      row: 1,
      keys: [
        { id: 'Backquote', display: '`', shifted: '~' },
        { id: 'Digit1', display: '1', shifted: '!' },
        { id: 'Digit2', display: '2', shifted: '@' },
        { id: 'Digit3', display: '3', shifted: '#' },
        { id: 'Digit4', display: '4', shifted: '$' },
        { id: 'Digit5', display: '5', shifted: '%' },
        { id: 'Digit6', display: '6', shifted: '^' },
        { id: 'Digit7', display: '7', shifted: '&' },
        { id: 'Digit8', display: '8', shifted: '*' },
        { id: 'Digit9', display: '9', shifted: '(' },
        { id: 'Digit0', display: '0', shifted: ')' },
        { id: 'Minus', display: '-', shifted: '_' },
        { id: 'Equal', display: '=', shifted: '+' },
        { id: 'Backspace', display: 'delete', className: 'long alert' }
      ]
    },
    {
      row: 2,
      keys: [
        { id: 'Tab', display: 'tab', className: 'long' },
        { id: 'KeyQ', display: 'q' },
        { id: 'KeyW', display: 'w' },
        { id: 'KeyE', display: 'e' },
        { id: 'KeyR', display: 'r' },
        { id: 'KeyT', display: 't' },
        { id: 'KeyY', display: 'y' },
        { id: 'KeyU', display: 'u' },
        { id: 'KeyI', display: 'i' },
        { id: 'KeyO', display: 'o' },
        { id: 'KeyP', display: 'p' },
        { id: 'BracketLeft', display: '[', shifted: '{' },
        { id: 'BracketRight', display: ']', shifted: '}' },
        { id: 'Backslash', display: '\\', shifted: '|' }
      ]
    },
    {
      row: 3,
      keys: [
        { id: 'CapsLock', display: 'caps lock', className: 'long' },
        { id: 'KeyA', display: 'a' },
        { id: 'KeyS', display: 's' },
        { id: 'KeyD', display: 'd' },
        { id: 'KeyF', display: 'f' },
        { id: 'KeyG', display: 'g' },
        { id: 'KeyH', display: 'h' },
        { id: 'KeyJ', display: 'j' },
        { id: 'KeyK', display: 'k' },
        { id: 'KeyL', display: 'l' },
        { id: 'Semicolon', display: ';', shifted: ':' },
        { id: 'Quote', display: "'", shifted: '"' },
        { id: 'Enter', display: 'return', className: 'long alert' }
      ]
    },
    {
      row: 4,
      keys: [
        { id: 'ShiftLeft', display: 'shift', className: 'long modifier' },
        { id: 'KeyZ', display: 'z' },
        { id: 'KeyX', display: 'x' },
        { id: 'KeyC', display: 'c' },
        { id: 'KeyV', display: 'v' },
        { id: 'KeyB', display: 'b' },
        { id: 'KeyN', display: 'n' },
        { id: 'KeyM', display: 'm' },
        { id: 'Comma', display: ',', shifted: '<' },
        { id: 'Period', display: '.', shifted: '>' },
        { id: 'Slash', display: '/', shifted: '?' },
        { id: 'ShiftRight', display: 'shift', className: 'long modifier' }
      ]
    },
    {
      row: 5,
      keys: [
        { id: 'ControlLeft', display: 'Ctrl', className: 'modifier' },
        { id: 'MetaLeft', display: '⊞', className: 'modifier' },
        { id: 'AltLeft', display: 'Alt', className: 'modifier' },
        { id: 'Space', display: '', className: 'long space' },
        { id: 'AltRight', display: 'Alt', className: 'modifier' },
        { id: 'MetaRight', display: '⊞', className: 'modifier' },
        { id: 'ControlRight', display: 'Ctrl', className: 'modifier' }
      ]
    }
  ]
};
